// extracted by mini-css-extract-plugin
module.exports = {"rich":"richText_rich__tdtLn"};